import { render, staticRenderFns } from "./Not-Found.vue?vue&type=template&id=e42232a6&scoped=true"
import script from "./Not-Found.vue?vue&type=script&lang=js"
export * from "./Not-Found.vue?vue&type=script&lang=js"
import style0 from "./Not-Found.vue?vue&type=style&index=0&id=e42232a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e42232a6",
  null
  
)

export default component.exports